module.exports = __webpack_public_path__ + "fonts/icomoon-ultimate.e788cdf.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/theme/assets/common/fonts/icomoon-ultimate.ttf?i14t76
// module id = ./assets/theme/assets/common/fonts/icomoon-ultimate.ttf?i14t76
// module chunks = 152